import { render, staticRenderFns } from "./twitterdialog.vue?vue&type=template&id=81f2c1b0&"
import script from "./twitterdialog.vue?vue&type=script&lang=js&"
export * from "./twitterdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81f2c1b0')) {
      api.createRecord('81f2c1b0', component.options)
    } else {
      api.reload('81f2c1b0', component.options)
    }
    module.hot.accept("./twitterdialog.vue?vue&type=template&id=81f2c1b0&", function () {
      api.rerender('81f2c1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/twitterdialog.vue"
export default component.exports